// https://github.com/chakra-ui/chakra-ui/blob/develop/packages/theme/src/components/tooltip.ts
export const Tooltip = {
  baseStyle: (props) => ({
    px: '1rem',
    py: '0.625rem',
    borderRadius: 'lg',
    pointerEvents: 'initial',
  }),
}
